import { combineReducers } from 'redux';

import highlights from './highlights/reducer';
import projects from './projects/reducer';

export default combineReducers({ 
  highlights,
  projects,
});
